import { Button, Flex, Text } from "@chakra-ui/core";
import React from "react";
import { Link } from "react-router-dom";

export const CallToAction = () => {
  return (
    <Flex justify='center' py='40' bg='#9CCD6C' align='center'>
      <Flex
        spacing='8'
        align='center'
        direction={["column", "column"]}
        justify='center'
      >
        <Text
          color='#fff'
          fontWeight='900'
          fontSize={["xl", "4xl"]}
          textAlign='center'
          fontFamily='Familiar Pro'
          mr={["0", "4"]}
        >
          Find Green Opportunities
        </Text>
        <Flex mt={["2", "6"]}>
          <Link to='auth/sign-in'>
            <Button
              rightIcon='arrow-forward'
              bg='white'
              color='green.600'
              alignContent='center'
              size={["md", "lg"]}
              p={["2"]}
              mr={["2", "6"]}
              w={["auto", "150px"]}
            >
              Sign In
            </Button>
          </Link>

          <Link to='/auth'>
            <Button
              rightIcon='arrow-forward'
              bg='white'
              color='green.600'
              p={["2", "2"]}
              // size={["md", "lg"]}
              w={["auto", "150px"]}
            >
              Sign Up
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};
